<template>
  <div>
    <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
    <el-breadcrumb-item :to="{ path: '/text' }">首页</el-breadcrumb-item>
    <el-breadcrumb-item>工作汇报</el-breadcrumb-item>
    <el-breadcrumb-item>KPI查看</el-breadcrumb-item>
    
  </el-breadcrumb>
  <el-card v-loading="loading">
    <el-row :gutter="10">
  <el-col :span="3"><div class="grid-content bg-purple-dark"><el-input v-model="searDate"  @keyup.enter.native="TitleList" placeholder="授课老师"></el-input></div></el-col>
  <el-col :span="7">
   <div class="block">
    <el-date-picker
      v-model="value2"
      type="daterange"
      align="right"
      unlink-panels
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      :picker-options="pickerOptionss">
    </el-date-picker>
  </div>
        </el-col>

        <el-col :span="2"><p class="lableforP">考核周期：</p></el-col>

   <el-col :span="2">
        <el-select v-model="value" placeholder="考核年份">
          <el-option
            v-for="item in year"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
        </el-col>
      <el-col :span="2">
        <el-select v-model="value3" placeholder="考核月份">
          <el-option
            v-for="item in moun"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
    
    </el-col>


    <el-col :span="1.5" :offset="1"><div class="grid-content bg-purple"> <el-button type="primary" @click="TitleList">查询</el-button></div></el-col>
    <el-col :span="2"><div class="grid-content bg-purple"> <el-button type="primary" :disabled="multipleSelection.length>0?false:true" @click="outData">导出</el-button></div></el-col>
    <el-col :span="3"> <p class="lableforP">查询到{{kpiList.length}}条数据</p></el-col>

</el-row>
    <el-table
    :data="kpiList"
    ref="multipleTable"
    border
    @selection-change="handleSelectionChange"
    style="width: 100%">
    <el-table-column
      type="selection"
      width="55">
    </el-table-column>

    <el-table-column
      prop="teacher"
      label="授课老师"
      show-overflow-tooltip
      width="100">
    </el-table-column>
    <el-table-column
      prop="sub_date"
      show-overflow-tooltip
      label="提交时间"
      width="130">
    </el-table-column>
    <el-table-column
      width="180"
      prop="total_points"
      label="总分"
    >
    </el-table-column>
    <el-table-column
      width="180"
      prop="money"
      label="酬金">
    </el-table-column>
    <el-table-column
      width="180"
      prop="teacherUnit"
      label="所在部门">
    </el-table-column>
    <el-table-column
      width="180"
      prop="leader_after_score"
      label="检查后分数">
    </el-table-column>
    <el-table-column
      width="180"
      prop="leader_after_money"
      label="检查后金额">
    </el-table-column>
    <el-table-column
      label="操作" 
      width="320">
      <template slot-scope="scope">
        <el-button   @click="catKpi(scope.row)"><svg class="icon" aria-hidden="true"><use xlink:href="#icon-chakan2"></use></svg></el-button>
        <el-button   @click="exportKpi(scope.row)">导出pdf</el-button>
<el-button v-if="userId==scope.row.sub_user_id"  @click="deleteKpiById(scope.row)"><svg class="icon" aria-hidden="true"><use xlink:href="#icon-shanchu"></use></svg></el-button>
</template>
    </el-table-column>
  </el-table>
  </el-card>
  <div >
  <el-dialog
  :visible.sync="dialogVisible"
  width="90%"
 >

<ComponentsSupervise @func="getData" :formInline="formInline" :pdfDown="pdfDown" :fileList="fileList"></ComponentsSupervise>

<el-button type=" primary" @click="dialogVisible=false">取消</el-button>
</el-dialog>
<div v-show="false">
</div>
</div>
  </div>
  </div>
</template>

<script>
  import ComponentsSupervise from '@/components/work/teacher/leaderKpiDemo.vue'
export default {
    components:{ComponentsSupervise},
    created(){
        this.getKpi()
    },
    data(){
      return{
        pickerOptionss: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        loading:false,
        value: '',
        value3: '',
        year:[],
        moun:[],
        pdfDown:false,
        value2:'',
        searTitleList:'',
        multipleSelection: [],
        searDate:'',
        kpiList:[],
        formInline:{},
        dialogVisible:false,
        fileList:[],
        kpiId:'',
        userId:'',
      }
    },methods:{
      getData(data){
             this.dialogVisible=false
         this.pdfDown=false
         this.loading=false
      },
        getKpi(){
          this.getYearDateList()
          this.getMonthlIST()
        this.userId=JSON.parse(localStorage.getItem('user')).userid  
            this.axios.post("/kpi/getKpiByUser")
         .then(resp => { 
                       if(resp.data.status == 1) {
                            this.kpiList=resp.data.result
                            console.log(this.kpiList)
                                }else {
                               
                                       alert("出错")                          
                                }
                            })
                            .catch((err) => {
                                alert("出错了")
                                console.log(err)
                            }) 
        },
        handleSelectionChange(val) {
        this.multipleSelection = val;
      },async exportKpi(data){
         this.loading=true
        this.pdfDown=true
        this.catKpi(data)

        // this.dialogVisible=false
        // this.pdfDown=false
      }, 
        getFile(){
          this.axios.post("/file/getFile?useId="+ this.kpiId)
         .then(resp => { 
          console.log(resp)
                       if(resp.data.status == 1) {
                        this.fileList=resp.data.result
                                }
                            })
                            .catch((err) => {
                                alert("出错了")
                                console.log(err)
                            }) 
        },      outData(){

this.axios({
url: "/kpi/outKpi",   //后端地址
method: "post",
data:this.multipleSelection, //请求参数
headers: {  
'Access-Control-Allow-origin': '*', 'Content-Type': 'application/json; charset=UTF-8',
},
// contenType:'application/json',
responseType: "blob"
})
.then(res => {
  const blob = new Blob([res.data], { type: 'xlsx' });
  const fileName = "KPI数据报表.xlsx"; 
    const elink = document.createElement("a");
    elink.download = fileName;
    elink.style.display = "none";
    elink.href = URL.createObjectURL(blob);
    document.body.appendChild(elink);
    elink.click();
    URL.revokeObjectURL(elink.href); // 释放URL 对象
    document.body.removeChild(elink); 
    this.selectData=false
})
},
        catKpi(data){
          this.kpiId=data.kpi_id
      this.dialogVisible=true
      this.getFile()
      console.log(data)
      this.formInline=data
        },TitleList(){
    const starDate=this.$formateDate.format(this.value2[0], 'yyyy-MM-dd HH:mm:ss')
      const endDate=this.$formateDate.format(this.value2[1], 'yyyy-MM-dd HH:mm:ss')
    if(this.searTitleList.length<=0){
          this.searTitleList=this.kpiList
        }
        this.kpiList=this.searTitleList
        // .includes
        this.kpiList=this.kpiList.filter((item)=>{
         if(this.searDate!=''){
          console.log(item.teacher,this.searDate)
          return item.teacher.includes(this.searDate)
         }else{
          return true
         }     
        })

        
        this.kpiList=this.kpiList.filter((item)=>{
         if(this.value2.length>0){
          return starDate<item.sub_date&&item.sub_date<endDate
         }else{
          return true
         }     
        })

        this.kpiList=this.kpiList.filter((item)=>{
         if(!(this.value==''||this.value=='无'||this.value3==''||this.value3=='无')){
           let kpidate=this.value+'-'+(this.value3>9?this.value3:'0'+this.value3)
          return item.kpi_time==kpidate
         }else{
          return true
         }     
        })

       
  },deleteKpiById(data){
          const that=this
        this.$confirm("确定删除？","提示",{
          confirmButtonText: "确认",//确认按钮文字更换
          cancelButtonText: "取消",//取消按钮文字更换
          showClose: true,//是否显示右上角关闭按钮
          type: "warning",//提示类型  success/info/warning/error
      }).then(function(){  
        that.axios.post("/kpi/deleteKpiById?kpi_id="+ data.kpi_id)
         .then(resp => { 
          console.log(resp)
                       if(resp.data.status == 1) {
                        that.$message.success("删除成功")
                        that.getKpi()
                                }
                            })
                            .catch((err) => {
                                alert("出错了")
                                console.log(err)
                            }) 
      })
        },     getYearDateList(){
      var date = new Date()
    var Y = date.getFullYear()
    console.log(Y)
   let yearList=[]
      yearList.push('无')
   yearList.push(Y-1)
   yearList.push(Y)
   yearList.push(Y+1)
    this.value=Y
   this.year=yearList
       },
       getMonthlIST(){
        var date = new Date()
        var M = (date.getMonth() + 1)
        let mounList=[]
          mounList.push('无')
        for (let index = 1; index <13; index++) {
        mounList.push(index)  
        }
      this.moun=mounList
      // this.value3=M
       },
    }
}
</script>

<style>
  .lableforP{
      margin-top:8px;

    }


</style>


// WEBPACK FOOTER //
// src/components/work/leader/ViewKpi.vue